import React, {
  useState,
  useEffect,
} from 'react';
import {
  Stack,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { feedSelector } from '../../../redux/slices/feed';
import FilterItem from '../filterItem/FilterItem';
import { buildFilterItems } from './utils';

const FilterBar = ({
  filterMeta = null,
  onChangeCallBack = () => { },
  disableClickEventsOverrideRef = null,
  useFeedSelector = true,
  selectedValue = 'all',
}) => {
  const feedState = useSelector(feedSelector);
  const [filterItems, setFilterItems] = useState([]);

  const handleOnChange = (filter) => {
    onChangeCallBack(filter);
  };

  useEffect(() => {
    const filters = buildFilterItems(
      filterMeta,
      handleOnChange,
      useFeedSelector ? feedState.activeFilter.value : selectedValue,
    );
    setFilterItems(filters);
  }, [filterMeta, useFeedSelector ? feedState.activeFilter.value : selectedValue]);

  return (
    <Stack
      direction="row"
      spacing={3}
    >
      {filterItems.length > 0 && filterItems.map((f) => (
        <FilterItem
          key={f.filterMeta.value}
          filterMetaItem={f.filterMeta}
          isSelected={f.isSelected}
          onClickCallBack={f.onClickCallBack}
          size={f.size}
          disableClickEventsOverrideRef={disableClickEventsOverrideRef}
        />
      ))}
    </Stack>
  );
};

FilterBar.propTypes = {
  filterMeta: PropTypes.oneOfType([PropTypes.array]),
  onChangeCallBack: PropTypes.func,
  disableClickEventsOverrideRef: PropTypes.oneOfType([PropTypes.object]),
  useFeedSelector: PropTypes.bool,
  selectedValue: PropTypes.string,
};


export default FilterBar;
